import apiClient from './client'
import type {
  MultiSymbolAnalysisRequest,
  AnalysisType
} from '@/types/multi-symbol'

export interface MultiSymbolAnalyzeJobResponse {
  success: boolean
  jobId: string
  status: string
}

export const multiSymbolApi = {
  /**
   * Start multi-symbol analysis (creates a job). Returns jobId; poll GET /jobs/:id for status and result.
   */
  analyze: async (request: MultiSymbolAnalysisRequest): Promise<MultiSymbolAnalyzeJobResponse> => {
    const response = await apiClient.post('/multi-symbol/analyze', request)
    return response.data
  },

  /**
   * Get available analysis types
   */
  getAnalysisTypes: async (): Promise<{
    analysisTypes: AnalysisType[]
  }> => {
    const response = await apiClient.get('/multi-symbol/types')
    return response.data.data
  }
}